import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  IStudentPerformanceData,
  IStudentSubmissionsData,
  ICourseSubmissionsData,
  ITopicGroupedSubmission,
} from '.';
import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';

export type TGetSubmissionsByStudent = {
  courseId: string;
  studentId: string;
};

export type TGetSubmissionsByTopic = {
  topicId: string;
  studentId: string;
};

const apiDataProvider = new APIDataProvider();

export const getSubmissionsByCourse = createAsyncThunk(
  '/submissions/getByCourse',
  async (courseId: string) => {
    const path = `${ApiPaths.submissions}/course/${courseId}`;

    const response = await apiDataProvider.get<
      TApiResponse<ICourseSubmissionsData>
    >(path);

    return response.data;
  }
);

export const getSubmissionsByStudent = createAsyncThunk(
  '/submissions/getByStudent',
  async (data: TGetSubmissionsByStudent) => {
    const path = `${ApiPaths.submissions}/course/${data.courseId}/student?courseId=${data.courseId}&studentId=${data.studentId}`;

    const response = await apiDataProvider.get<
      TApiResponse<IStudentSubmissionsData>
    >(path);

    return response.data;
  }
);

export const getSubmissionsGroupedByStudents = createAsyncThunk(
  '/submissions/getGroupedByStudents',
  async (courseId: string) => {
    const path = `${ApiPaths.submissions}/course/${courseId}/students`;

    const response = await apiDataProvider.get<
      TApiResponse<IStudentPerformanceData[]>
    >(path);

    return response.data;
  }
);

export const getSubmissionsGroupedBySubTopic = createAsyncThunk(
  '/submissions/getGroupedBySubTopic',
  async (data: TGetSubmissionsByTopic) => {
    const path = `${ApiPaths.submissions}/topic/${data.topicId}/student?topicId=${data.topicId}&studentId=${data.studentId}`;

    const response = await apiDataProvider.get<
      TApiResponse<ITopicGroupedSubmission>
    >(path);

    return response.data;
  }
);
